import { useEffect } from 'react';

import { useStartingMaterialPrice } from '@f/hooks';
import { PriceMap } from '@f/hooks/useStartingMaterialPrice';

export interface PriceQueryProps {
  smilesList: string[];
  onPricesReady: (priceMap: PriceMap) => unknown;
}

export function PriceQuery(props: PriceQueryProps) {
  const { smilesList, onPricesReady = () => {} } = props;

  const priceMap = useStartingMaterialPrice({ smilesList });

  useEffect(() => {
    onPricesReady(priceMap);
  }, [priceMap]);

  return null;
}
